import type { SchoolResponse } from '@shared/schemas';

/** Rows per page, matching the original `useInfiniteApi('/schools')` default. */
export const DEFAULT_PAGE_SIZE = 25;

/**
 * Redux state for the client's own Schools list. Server-side pagination: the slice
 * holds the current page's rows, the grand `total`, the load lifecycle (`error` is
 * a human-readable banner message), and the current page / pageSize (`page` is
 * 0-indexed, as MUI DataGrid emits). Every field is serialisable.
 */
export interface MySchoolsState {
  rows: SchoolResponse[];
  total: number;
  loading: boolean;
  error: string | null;
  page: number;
  pageSize: number;
}

export const initialState: MySchoolsState = {
  rows: [],
  total: 0,
  loading: false,
  error: null,
  page: 0,
  pageSize: DEFAULT_PAGE_SIZE,
};
